<template>
  <div class="gant-lane" :style="'height:100%;background-position:'+pageOffset+'px;'">
    <div :class="' line ' + (node.errors ? ' error ' : '')" :title="node.errors" :style="'margin-left:'+lineOffset+'px; width: '+lineWidth+'px;'">
      <i @click="$emit('laneClick', node)">
        <b class="assignee" :style="'margin-left:'+taskLeftOffset+'px; width:'+taskWidth+'px;'"></b>
        <b v-if="node.acceptor_start_time>0" class="acceptor" :style="'width:'+acceptWidth+'px;margin-left:'+acceptLeftOffset+'px;'"></b>
      </i>
    </div>
  </div>
</template>

<script>

/**
 * Tasks object
 */

export default {

  components: {},

  data: () => ({
    startDrag: 0,
    currentOffset: 0
  }),

  props: ["node"],

  // Computed vars
  computed: {

    /**
     * Page offset
     */

    pageOffset() {
      return 20 * Math.floor(this.$get('misc/var', 'gantt-days-offset'));
    },

    /**
     * Get line offset
     */

    lineOffset() {
      return 20 * (this.node.child_start_time - this.$get('misc/var', 'gantt-start-day') - 1) + this.pageOffset;
    },

    /**
     * Get line width
     */

    lineWidth() {
      return 20 * (this.node.end_time - this.node.child_start_time + 1);
    },

    /**
     * Get task width
     */

    taskWidth() {
      return this.node.type === 'task' ? 20 * (this.node.assignee_end_time - this.node.start_time + 1)-7 : 0;
    },

    /**
     * Get task left offset
     */

    taskLeftOffset() {
      return this.node.type === 'task' ? 20 * (this.node.start_time - this.node.child_start_time) : 0;
    },

    /**
     * Get task acceptance width
     */

    acceptWidth() {
      return this.node.type === 'task' ? 20 * (this.node.acceptor_end_time - this.node.acceptor_start_time + 1) - 7 : 0;
    },

    /**
     * Get task acceptance right offset
     */

    acceptLeftOffset() {
      return this.node.type === 'task' ? 20 * (this.node.acceptor_end_time - this.node.child_start_time) : 0;
    },

    /**
     * Get node error
     */

    nodeError() {
      return this.node.errors.replace(/{{(.+)}}/g, () => (""))
    }

  },

  methods: {
    /**
     * Get node error
     */

    gotoErrorNode() {

      // Extract id and go to task
      this.node.errors.replace(/{{(.+)}}/g, (match, contents) =>
          {
            this.$dispatch('misc/var', {name: 'show-task-details', val: 0})
            this.$router.replace({name: "tree", params: {task_id: contents}});
          }
      );
    },
  }
}

</script>

<style lang="scss">

.tree-tasks {
  .input-group-append {
    border-bottom: 2px solid #ddd;
  }

  .active .input-group-append {
    background: #ffa3;
    border-bottom: 2px solid #666;
  }

  .gant-lane {
    margin-left: 20px;
    width: 50vw;
    background: url("~@/assets/images/gantt-grid.png");
    background-size: 140px;
    overflow: hidden;

    .line.error i {
      background: #a00;
      cursor: help;
    }

    .line {
      display: inline-block;
      height: 100%;
      padding: 8px 4px 8px 4px;
      cursor: pointer;

      i {
        position: relative;
        border-radius: 10px;
        height: 100%;
        width: 100%;
        background: #ddf;
        display: block;
        overflow: hidden;

        b {
          position: absolute;
          height: 100%;
          display: block;
          border-radius: 10px;
        }
      }

      .assignee {
        background: #00f;
      }

      .acceptor {
        background: #f00;
        opacity: 0.5;
        padding:5px;
      }

    }
  }
}

</style>
